/**
 * Runs `callback` once the DOM is ready.
 *
 * Several entry scripts can load with `async` on lean embed pages (e.g. the
 * creditcard iframe page), where DOMContentLoaded may already have fired by
 * the time the script executes. This runs immediately in that case instead
 * of waiting for an event that already happened.
 */
export function domReady(callback) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
    } else {
        callback();
    }
}
